<template>
  <div>
    <TopMenu :leftOption="'menu'">
      <template slot="right">
        <router-link :to="ROUTE_BOXES"><FontAwesomeIcon icon="ellipsis-v" /></router-link>
      </template>
    </TopMenu>
    <div class="view" v-on:scroll="scrollHandler($event)">
      <transition name="fade" appear>
        <div>
          <div v-if="providerImage" style="padding: 12px">
            <div
              class="bg-gray px-4 py-1 d-block d-flex justify-content-center rounded"
              style="box-shadow: black 2px 3px 12px; padding: 8px !important;"
            >
              <div v-if="providerImage" id="queue" class="">
                <img :src="providerImage" class="provider_image">
              </div>
<!--              <div v-if="news.image">-->
<!--                <img :src="news.image" alt="news" width="105" height="105">-->
<!--              </div>-->
<!--              <div style="padding: 0px 4px 0px 12px">-->
<!--                <h5>{{ news.title }}</h5>-->
<!--                <div>{{ news.text }}</div>-->
<!--              </div>-->
            </div>
          </div>
<!--          <div v-if="currentNews" style="padding: 12px">-->
<!--            <template v-if="currentNews.link">-->
<!--              <router-link v-if="currentNews.link.startsWith('/')" :to="currentNews.link" class="text-white">-->
<!--                <News :news="currentNews" />-->
<!--              </router-link>-->
<!--              <a v-else :href="currentNews.link" target="_blank" class="text-white"><News :news="currentNews" /></a>-->
<!--            </template>-->
<!--            <News v-else :news="currentNews" />-->
<!--          </div>-->
          <div style="padding: 4px">
            <div v-if="showIsPlayerOfflineNotification" class="notification_box">
              <span class="notification_box_inner">
                <FontAwesomeIcon icon="exclamation-circle" class="text-danger i"/> {{$t('Player offline')}}
              </span>
            </div>
          </div>
          <div class="p-4">{{$t('Song Queue')}}</div>
          <template v-if="boxStatus != null">
            <draggable v-model="songQueue" :options="{handle:'.drag-target'}" @start="dragStart()" @end="dragEnd()">
              <div v-for="(song, index) in songQueue" v-bind:key="index" class="px-1 mb-1">
                <div class="bg-dark px-4 py-1 d-block d-flex justify-content-start align-items-center rounded clickable">
                  <span class="py-2 pr-2 mr-2 text-muted drag-target"><FontAwesomeIcon icon="bars" /></span>
                  <SongCover
                    :coverUrl="song.cover_url"
                    :alt="song.title + ' cover'"
                    :size="40"
                    class="mr-3"
                  />
                  <div>
                    <p class="text-white m-0 p-0">{{ song.title }} <br>
                      <small class="text-muted">{{ song.artist }} - {{ song.minutesAndSeconds }}</small>
                    </p>
                  </div>
                  <span
                    @click="removeFromQueue(song)"
                    :style="{ display: !removeFromQueueSongs.has(song.id) ? 'inline-block' : 'none' }"
                    class="ml-auto"
                  ><FontAwesomeIcon icon="times" class="i text-danger" /></span>
                  <span
                    :style="{ display: removeFromQueueSongs.has(song.id) ? 'inline-block' : 'none' }"
                    class="ml-auto"
                  ><FontAwesomeIcon icon="spinner" spin /></span>
                </div>
              </div>
            </draggable>
          </template>
          <router-link class="py-3 px-4 clickable bg-gray text-center d-block" to="/addsongs">
            <small>
              <FontAwesomeIcon icon="plus" class="text-primary mr-2" /> <span class="text-muted">{{$t('Add Songs')}}</span></small>
          </router-link>
          <div style="height: 100px">&nbsp;</div>
        </div>
      </transition>
    </div>
    <div style="flex-direction: column" class="footer d-flex pt-1 pb-2 px-1">
      <div v-if="isWebBox && serverIsStreaming" style="display: flex; flex-direction: row-reverse; padding: 4px;">
        <button
          @click.prevent="toggleLocalAudio()"
          class="play-audio-stream btn btn-dark btn-block text-center text-default clickable px-4 bg-primary"
          style="width: auto; min-width: 230px"
        >
          <transition name="fade" appear>
            <span key="stopOnDev" v-if="isPlaying"><FontAwesomeIcon icon="pause" class="text-default" /> <span style="padding-left: 5px">{{$t('Stop on this device')}}</span></span>
            <span key="playOnDev" v-else><FontAwesomeIcon icon="play" class="text-default" /> <span style="padding-left: 5px">{{$t('Listen on this device')}}</span></span>
          </transition>
        </button>
      </div>
      <div class="d-flex justify-content-start align-items-center pt-1 pb-2 px-1">
        <span style="min-width: 34px">
          <span v-if="serverIsStreaming" @click.prevent="goToPlaylists()" class="px-2 mr-2 font-button">
            <FontAwesomeIcon icon="eject" class="text-primary" />
          </span>
        </span>
        <SongCover
          :coverUrl="playerCoverUrl"
          alt="Now playing cover"
          :size="48"
          class="mr-3"
        />
        <span v-if="!isPlaying">&nbsp;</span>
        <div style="flex: 1; white-space: nowrap; overflow: hidden">
          <div style="overflow: hidden">
            <small class="text-muted">{{ boxStatus && boxStatus.playlist ? boxStatus.playlist : '' }}&nbsp;</small>
          </div>
          <div style="overflow: hidden">
            <span v-if="!isPlayerOffline">{{ boxStatus.title }}</span>
            <span v-else>{{$t('Stopped')}}</span>
            <span>&nbsp;</span>
          </div>
          <div style="overflow: hidden">
            <small v-if="!isPlayerOffline" class="text-muted">{{ boxStatus.artist != null ? boxStatus.artist : '' }}&nbsp;</small>
            <small v-else>&nbsp;</small>
          </div>
        </div>
        <div class="ml-auto" style="min-width: 70px">
          <transition name="fade">
            <span key="pause" v-if="!isPlayerOffline &&   serverIsStreaming" @click="pause" class="font-button p-2">
              <FontAwesomeIcon icon="pause" class="text-primary" />
            </span>
            <span key="play" v-if="!serverIsStreaming" @click="play" class="font-button p-2">
              <FontAwesomeIcon icon="play" class="text-primary" />
            </span>
          </transition>
          <span v-if="!isPlayerOffline && serverIsStreaming" @click.prevent="skipCurrentSong()" class="font-button p-2 ml-2">
            <FontAwesomeIcon icon="step-forward" class="text-primary" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ROUTE_MENU, ROUTE_PLAYLISTS, ROUTE_BOXES } from '@/const/routeNames'
import audioManager from '@/utils/audioManager'
import musicboxClient from '@/utils/musicboxClient'
import scrollHandler from '@/utils/scrollHandler'
// import browserUtils from '@/utils/browserUtils'
import draggable from 'vuedraggable'
import SongCover from '@/components/shared/SongCover.vue'

var newsPollingId = null

export default {

  name: 'Dashboard',

  components: { draggable, SongCover },

  mounted () {
    this.getNews()
    if (newsPollingId != null) { return }
    newsPollingId = setInterval(() => {
      this.getNews()
    }, 1000 * 60 * 60)
  },

  methods: {

    dragStart () {
      audioManager.pauseStatusUpdates()
    },

    dragEnd () {
      audioManager.continueStatusUpdates()
    },

    scrollHandler: scrollHandler('boxStatus.song_queue'),

    getNews () {
      musicboxClient
        .getNews()
        .then(res => { this.$store.commit('setNews', res.data) })
    },

    skipCurrentSong () {
      if (this.$store.state.audio.currentBox) {
        musicboxClient
          .skipCurrentSong(this.$store.state.audio.currentBox.uuid)
          .then(res => {
            this.$notify.success(this.$t('Skipping current song'))
          })
          .catch(e => {
            this.$notify.danger(this.$t('Skipping current song failed'))
          })
      }
    },

    removeFromQueue (song) {
      if (this.$store.state.audio.currentBox && !this.removeFromQueueSongs.has(song.id)) {
        this.removeFromQueueSongs.add(song.id)
        this.removeFromQueueSongs = new Set(this.removeFromQueueSongs)
        musicboxClient
          .removeSongFromQueue(this.$store.state.audio.currentBox.uuid, song.id)
          .then(res => {
            this.$notify.success('Removed ' + song.title)
            const newBoxStatus = Object.assign({}, this.$store.state.audio.boxStatus)
            for (var i = 0; i < newBoxStatus.song_queue.length; i++) {
              if (newBoxStatus.song_queue[i].id === song.id) {
                newBoxStatus.song_queue.splice(i, 1)
                break
              }
            }
            this.$store.commit('setBoxStatus', newBoxStatus)
          })
          .catch(e => {
            this.$notify.danger(this.$t('Failed removing {songTitle}', { songTitle: song.title }))
          })
          .then(() => {
            this.removeFromQueueSongs.delete(song.id)
            this.removeFromQueueSongs = new Set(this.removeFromQueueSongs)
          })
      }
    },

    play () {
      if (!this.$store.state.audio.currentBox) {
        this.$notify.danger(this.$t('No box selected'))
        return
      }
      if (
        this.$store.state.audio.boxStatus &&
        this.$store.state.audio.boxStatus.last_playlist &&
        this.$store.state.audio.boxStatus.last_playlist.id
      ) {
        musicboxClient
          .setBoxPlaylist(this.$store.state.audio.currentBox.uuid, parseInt(this.$store.state.audio.boxStatus.last_playlist.id, 10))
          .then(res => {
            this.$notify.success(this.$t('Playlist switched'))
            audioManager.forceUpdateStatus()
            /* if (this.$store.state.audio.currentBox.is_web) {
              setTimeout(() => { audioManager.play(this.$store.state.audio.currentBox.uuid) }, 512)
            } */
          })
          .catch(e => {
            this.$notify.danger(this.$t('Playlist switch failed'))
          })
        /* if (this.$store.state.audio.currentBox.is_web) {
          audioManager.play(this.$store.state.audio.currentBox.uuid)
        } */
      } else {
        this.$notify.info(this.$t('Select box playlist'))
        this.$router.push(ROUTE_PLAYLISTS)
      }
    },

    pause () {
      musicboxClient
        .stopBox(this.$store.state.audio.currentBox.uuid)
        .then(res => {
          this.$notify.success(this.$t('Stopped box stream'))
          audioManager.forceUpdateStatus()
          if (this.$store.state.audio.currentBox.is_web) {
            audioManager.pause()
          }
        })
        .catch(e => {
          this.$notify.danger(this.$t('Failed to stop box stream'))
        })
    },

    goToPlaylists () {
      this.$router.push(ROUTE_PLAYLISTS)
    },

    toggleLocalAudio () {
      if (this.$store.state.audio.audioPlaying) {
        audioManager.pause()
      } else {
        audioManager.play(this.$store.state.audio.currentBox.uuid)
      }
    }
  },

  computed: {
    providerImage () {
      const provider = this.$store.state.auth.userProvider
      if (provider !== null && this.userProviderImages.hasOwnProperty(provider.key)) {
        return this.userProviderImages[provider.key]
      }
      return null
    },
    showIsPlayerOfflineNotification () {
      return this.$store.state.audio.boxStatus && this.$store.state.audio.boxStatus.playlist && !this.$store.state.audio.boxStatus.listeners
    },
    isPlaying () {
      return this.$store.state.audio.audioPlaying
    },
    serverIsStreaming () {
      const serverIsStreaming = this.$store.state.audio.boxStatus && this.$store.state.audio.boxStatus.playlist != null && this.$store.state.audio.boxStatus.playlist !== ''
      /* if (browserUtils.isMobile && this.$store.state.audio.currentBox && this.$store.state.audio.currentBox.is_web) {
        return serverIsStreaming && this.$store.state.audio.audioPlaying
      } */
      return serverIsStreaming
    },
    isPlayerOffline () {
      if (this.$store.state.audio.boxStatus) {
        return this.$store.state.audio.boxStatus && this.$store.state.audio.boxStatus.playlist && !this.$store.state.audio.boxStatus.listeners
      }
      return true
    },
    playerCoverUrl () {
      // Priority 1: Current song's cover
      if (this.boxStatus && this.boxStatus.cover_url) {
        return this.boxStatus.cover_url
      }
      // Priority 2: Current playlist's cover (from box data)
      const box = this.$store.state.audio.currentBox
      if (box && box.playlist && box.playlist.cover_url) {
        return box.playlist.cover_url
      }
      // Priority 3: null (SongCover will show default)
      return null
    },
    songQueue: {
      get () { return this.boxStatus.song_queue.slice(0, this.displayLimit) },
      set (value) {
        const currentBoxStatus = Object.assign({}, this.$store.state.audio.boxStatus)
        currentBoxStatus.song_queue = value.concat(this.$store.state.audio.boxStatus.song_queue.slice(value.length))
        this.$store.commit('setBoxStatus', currentBoxStatus)
        musicboxClient.reorderQueue(this.$store.state.audio.currentBox.uuid, currentBoxStatus.song_queue.map(e => e.id))
          .then(res => { this.$notify.success('Songs reordered') })
          .catch(e => { this.$notify.danger('Failed to reorder songs') })
      }
    },
    isWebBox () {
      return this.$store.state.audio && this.$store.state.audio.currentBox && this.$store.state.audio.currentBox.is_web
    },
    boxStatus () {
      return this.$store.state.audio.boxStatus
    },
    hasMultipleBoxes () {
      return this.$store.state.audio.allBoxes != null && this.$store.state.audio.allBoxes.length > 1
    },
    currentNews () {
      return this.$store.state.shared.news
    }
  },

  data () {
    return {
      ROUTE_MENU,
      ROUTE_BOXES,
      removeFromQueueSongs: new Set(),
      displayLimit: 30,
      userProviderImages: {
        'garson': '../static/app/img/garson_banner.png'
      }
    }
  }
}
</script>

<style>
  img.provider_image {
    display:block;
    margin:auto;
    max-height:100%;
    max-width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue